"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIVE_TIGER = exports.MONTHLY_EARTHLY_BRANCHES = exports.ZODIAC = exports.EARTHLY_BRANCHES = exports.HEAVENLY_STEMS = void 0;
/**
 * 天干速查表
 */
exports.HEAVENLY_STEMS = [
    "甲",
    "乙",
    "丙",
    "丁",
    "戊",
    "己",
    "庚",
    "辛",
    "壬",
    "癸",
];
/**
 * 地支速查表
 */
exports.EARTHLY_BRANCHES = [
    "子",
    "丑",
    "寅",
    "卯",
    "辰",
    "巳",
    "午",
    "未",
    "申",
    "酉",
    "戌",
    "亥",
];
/** 十二生肖（按地支顺序） */
exports.ZODIAC = [
    "鼠",
    "牛",
    "虎",
    "兔",
    "龙",
    "蛇",
    "马",
    "羊",
    "猴",
    "鸡",
    "狗",
    "猪",
];
/**
 * 每月地支（按月序）
 */
exports.MONTHLY_EARTHLY_BRANCHES = [
    "寅",
    "卯",
    "辰",
    "巳",
    "午",
    "未",
    "申",
    "酉",
    "戌",
    "亥",
    "子",
    "丑",
];
/** 五虎遁速查表，按天干从甲开始 */
exports.FIVE_TIGER = [
    "丙",
    "戊",
    "庚",
    "壬",
    "甲",
    "丙",
    "戊",
    "庚",
    "壬",
    "甲",
];
